import { resetStore, resetStoreNoReload } from './slices/loaderSlice';
const initialState = {
    dashboardItems: [],
    applicationsItems: [],
    searchText: '',
    displayText: '',
    isOpen: false,
    activeTab: 'all',
    clearSignal: 0,
    pendingContractIdSearch: null,
};
export const GlobalSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_DASHBOARD_SEARCH_ITEMS':
            return Object.assign(Object.assign({}, state), { dashboardItems: action.payload });
        case 'SET_APPLICATIONS_SEARCH_ITEMS':
            return Object.assign(Object.assign({}, state), { applicationsItems: action.payload });
        case 'SET_GLOBAL_SEARCH_TEXT':
            return Object.assign(Object.assign({}, state), { searchText: action.payload });
        case 'SET_GLOBAL_SEARCH_DISPLAY_TEXT':
            return Object.assign(Object.assign({}, state), { displayText: action.payload });
        case 'SET_GLOBAL_SEARCH_OPEN':
            return Object.assign(Object.assign({}, state), { isOpen: action.payload });
        case 'SET_GLOBAL_SEARCH_ACTIVE_TAB':
            return Object.assign(Object.assign({}, state), { activeTab: action.payload });
        case 'CLEAR_GLOBAL_SEARCH':
            return Object.assign(Object.assign({}, state), { searchText: '', displayText: '', isOpen: false, activeTab: 'all', clearSignal: state.clearSignal + 1 });
        case 'SET_PENDING_CONTRACT_ID_SEARCH':
            return Object.assign(Object.assign({}, state), { pendingContractIdSearch: action.payload });
        case 'CLEAR_PENDING_CONTRACT_ID_SEARCH':
            return Object.assign(Object.assign({}, state), { pendingContractIdSearch: null });
        case resetStore.type:
        case resetStoreNoReload.type:
            return initialState;
        default:
            return state;
    }
};
